import { z } from "zod";
export const SearchRequirementSchema = z.object({
    id: z.string().describe("Requirement identifier (e.g., A, B)"),
    requirement: z.string().describe("Natural-language search requirement"),
});
export const SearchSubAgentParamsSchema = z.object({
    requirements: z
        .array(SearchRequirementSchema)
        .min(1)
        .describe("One or more search requirements to satisfy."),
});
